import React from 'react';
import { NodeViewWrapper } from '@tiptap/react';
import { Chip } from '@mui/material';

/**
 * React component for rendering placeholder nodes in the editor
 * Displays placeholders as styled chips that are visually distinct
 * Validates: Requirements 3.4 - Style placeholder tokens distinctly
 */
const PlaceholderComponent = ({ node }) => {
  const { token, label } = node.attrs;
  
  return (
    <NodeViewWrapper as="span" style={{ display: 'inline-block' }}>
      <Chip
        label={label || token}
        size="small"
        sx={{
          height: '26px',
          fontSize: '0.8rem',
          fontFamily: '"Fira Code", "Courier New", monospace',
          fontWeight: 600,
          backgroundColor: 'rgba(139, 95, 191, 0.12)',
          color: '#8B5FBF',
          border: '1.5px solid rgba(139, 95, 191, 0.3)',
          borderRadius: '6px',
          cursor: 'default',
          userSelect: 'none',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'rgba(139, 95, 191, 0.18)',
            borderColor: 'rgba(139, 95, 191, 0.5)',
            transform: 'scale(1.02)',
          },
          '& .MuiChip-label': {
            padding: '0 10px',
            letterSpacing: '0.02em',
          },
        }}
      />
    </NodeViewWrapper>
  );
};

export default PlaceholderComponent;
